/**
 * this is the right menu for the dashboard
 *
 * Created by Tom on 1/6/18
 */

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import cx from 'classnames'
import Parser from 'html-react-parser'

// action import
import {ActionCreator} from '../../actions/'

// style import
import './style.scss'

// icon imports
import BellIcon from '../../assets/svg/bell.svg'
import CloseIcon from '../../assets/svg/close.svg'
import CongratsImg from '../../assets/svg/congrats.svg'
import SpeakImg from '../../assets/svg/speak_directly.svg'

class RightMenu extends Component {

    _onOpenMenu() {
        const {setOpenRightMenu} = this.props
        // open the left menu
        setOpenRightMenu(true)
    }

    _onCloseMenu() {
        const {setOpenRightMenu} = this.props
        // close the left menu
        setOpenRightMenu(false)
    }

    _onCloseCongratsInfoBox() {
        const {setOpenCongratsInfoBox} = this.props
        //close the congratulation info box
        setOpenCongratsInfoBox(false)
    }

    render() {
        const {openRightMenu, openLeftMenu, openCongratsInfo} = this.props

        // TODO: this will come from API call
        const congratsText = '<p>A summary of your new SMSF information is found <a href="/documents">here</a> You can access this from the members area at any time.</p>'

        // switch on/off classes based on the truthy value 'openRightMenu'
        const dynClass = cx('right-menu-container', {'right-menu-container--open': openRightMenu})

        return (
            <div>
                <div
                    className="right-menu-open-container"
                    onClick={::this._onOpenMenu}>
                    <img
                        src={BellIcon}
                        className="right-menu-open-container__icon"
                        alt="Left menu close icon"/>
                </div>
                <div className={dynClass}>
                    <div
                        className="right-menu-container__close-container"
                        onClick={::this._onCloseMenu}>
                        <img
                            src={CloseIcon}
                            className="right-menu-container__close-icon"
                            alt="Left menu close icon"/>
                    </div>
                    <div className="right-menu">
                        {/* congrats info box */}
                        {
                            (openCongratsInfo &&
                                <div className="right-menu__top-container">
                                    <p
                                        className="right-menu__top-container__close-text"
                                        onClick={::this._onCloseCongratsInfoBox}>
                                        Close
                                    </p>
                                    <div className="right-menu__wrapper">
                                        <div className="right-menu__wrapper-left">
                                            <img
                                                src={CongratsImg}
                                                alt="Man on top podium"/>
                                        </div>
                                        <div className="right-menu__wrapper-right">
                                            <p className="right-menu__header-text">
                                                CONGRATULATIONS
                                            </p>
                                            <p className="right-menu__info-text">
                                                Your account and SMSF are set up
                                            </p>
                                            <div className="right-menu__info-text">
                                                {Parser(congratsText)}
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                        }

                        {/* pending actions container */}
                        <div
                            className="right-menu__middle-container">
                            <p className="right-menu__header-text">
                                PENDING ACTIONS
                            </p>

                            {/* TODO: action component here */}
                        </div>

                        {/* bottom info container */}
                        <div className="right-menu__bottom-container">
                            <div className="right-menu__wrapper">
                                <div className="right-menu__wrapper-left">
                                    <img
                                        src={SpeakImg}
                                        alt="Man on top podium"/>
                                </div>
                                <div className="right-menu__wrapper-right">
                                    <p className="right-menu__header-text">
                                        USE THIS SPACE TO SPEAK DIRECTLY TO USERS
                                    </p>

                                    <p className="right-menu__info-text">
                                        Lorem ipsum dolor sit amet, cetur incididunt ut labore
                                        et doloregna aliqua. enim veniam, quis nostrud
                                        exercitation ullamco laboris nisi ut aliquip.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
RightMenu.propTypes = {
    setOpenRightMenu: PropTypes.func.isRequired,
    setOpenCongratsInfoBox: PropTypes.func.isRequired,
    openRightMenu: PropTypes.bool,
    openLeftMenu: PropTypes.bool,
    openCongratsInfo: PropTypes.bool
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        openRightMenu: state.componentState.openRightMenu,
        openLeftMenu: state.componentState.openLeftMenu,
        openCongratsInfo: state.componentState.openCongratsInfo
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenRightMenu: action.setOpenRightMenu,
        setOpenCongratsInfoBox: action.setOpenCongratsInfoBox
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RightMenu)



// WEBPACK FOOTER //
// ./src/components/RightMenu/index.js